import type { Address } from "@/models/address.model"
import type { KnownBusinessEntity } from "@/models/known-business-entity.model"
import type { Location } from "@/models/location.model"

export function formatPostalAddress(address?: Address | null): string {
  if (!address) return ""

  const parts: string[] = []
  const streetLine = [address.street, address.houseNumber].filter(Boolean).join(" ").trim()
  if (streetLine) parts.push(streetLine)

  const cityLine = [address.postalCode, address.country].filter(Boolean).join(" ").trim()
  if (cityLine) parts.push(cityLine)

  return parts.join("\n")
}

export function formatKnownBusinessEntityAddress(business: KnownBusinessEntity): string {
  return getKnownBusinessEntityMainLocation(business)?.address?.trim() ?? ""
}

export function getKnownBusinessEntityMainLocation(business: KnownBusinessEntity): Location | null {
  const mainLocation = business.registeredBusinessEntity?.businessLocations?.find(
    (location) => location.isMain
  )
  return mainLocation?.location ?? null
}
